export const chunkzBuyerId = "user-chunkz-buyer";
export const chunkzDecisions = ["Yes", "Maybe", "No"] as const;
export type ChunkzDecision = "" | typeof chunkzDecisions[number];

export interface UseClassEvidence {
  status: "advertised_e" | "planning_check";
  headline: string;
  planning: string;
  suitability: string;
  sources: { label: string; url: string; quote?: string }[];
  checkedAt: string;
  councilCheckedAt?: string;
}

export interface ChunkzProperty {
  id: string;
  title: string;
  area: string;
  rent: number | null;
  ground: string;
  total: string;
  use: string;
  why: string;
  station: string;
  fit: string;
  costs: string;
  question: string;
  summary: string;
  agent: string;
  contact: string;
  status: string;
  listing: string;
  brochure: string;
  documents?: { name: string; url: string }[];
  photos: string[];
  credit: string;
  checkedAt: string;
  group: string;
  locationFit?: "priority" | "nearby" | "outside" | "unconfirmed";
  locationNote?: string;
  availability?: "marketed" | "check" | "unavailable";
  source?: string;
  teamNote?: string;
  rentNote?: string;
  useClass?: UseClassEvidence;
}

export const locationLabels = { priority: "Priority area", nearby: "Nearby NW London", outside: "Outside search area", unconfirmed: "Location unconfirmed" } as const;
export const availabilityLabels = { marketed: "On market · advertised online", check: "Market status to confirm", unavailable: "Off market / under offer" } as const;
export type AreaFilter = "within" | "all" | NonNullable<ChunkzProperty["locationFit"]>;
export function matchesArea(site: ChunkzProperty, filter: AreaFilter): boolean {
  const area = site.locationFit || "unconfirmed";
  return filter === "all" || (filter === "within" ? area === "priority" || area === "nearby" : area === filter);
}

export interface ChunkzNote {
  id: string;
  siteId: string;
  body: string;
  author: string;
  buyer: boolean;
  createdAt: string;
}

export interface ChunkzSite extends ChunkzProperty {
  decision: ChunkzDecision;
  version: number;
  updatedBy: string | null;
  updatedAt: string | null;
  notes: ChunkzNote[];
}

export interface ChunkzQueue {
  items: ChunkzSite[];
}
